import React from 'react'
import { ArrowRight, Info } from 'react-feather'

interface EnableRewardsProps {
  handleUpdateRewardConfig: (payload: any) => Promise<void>
}

import { useActivityLogs, EntityName } from 'src/lib/hooks/useActivityLogs'

const EnableRewards: React.FC<EnableRewardsProps> = ({ handleUpdateRewardConfig }) => {
  const { sendActivityLog } = useActivityLogs()
  return (
    <>
      <div className='flex flex-row items-center justify-between w-full h-full p-3 rounded-lg rewards-notactive_warning'>
        <div className='flex items-start gap-2'>
          <Info className='h-4 w-4 stroke-[2.5px] mt-0.5' color={'#C7981F'} />
          <div className='flex flex-col'>
            <p className='text-sm font-medium text-carbon'>Rewards is currently turned off</p>
            <p className='text-xs text-coal-light'>Customers will not be able to redeem or earn store credits</p>
          </div>
        </div>

        <div>
          <button
            className='flex items-center gap-1 px-3 py-2 text-sm font-semibold bg-white rounded-lg border-1 text-coal-dark max-w-fit'
            onClick={() => {
              handleUpdateRewardConfig({ active: true })
              const activityLogPayload = {
                entityName: EntityName.REWARDS,
                actionName: 'enabled the configuration'
              }
              sendActivityLog(activityLogPayload)
            }}
          >
            Enable Shopflo Rewards
            <ArrowRight className='h-4 w-4 stroke-[2.5px]' color={'#4D4D4D'} />
          </button>
        </div>
      </div>
    </>
  )
}

export default React.memo(EnableRewards)
